import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'

import {
  ReorderListSourcingRBAC,
  ReorderListHistoryRBAC,
  ReorderListScRBAC,
  ReorderListPreviewRBAC,
} from './rbac'

const ReorderListSavePreview = lazy(() => import('../pages/ReorderListSavePreview'))
const ReorderListSourcing = lazy(() => import('../pages/ReorderListSourcing'))
const ReorderListSC = lazy(() => import('../pages/ReoderListSC'))
const ReorderListHistory = lazy(() => import('../pages/ReorderListHistory'))

export const ReorderListSourcingRouter: RouterFeatureInterface<
  'ReorderListSourcingRouter',
  '/dashboard/reorder-list-sourcing'
> = {
  name: 'ReorderListSourcingRouter',
  Component: ReorderListSourcing,
  path: '/dashboard/reorder-list-sourcing',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: ReorderListSourcingRBAC.pageID,
}

export const ReorderListSCRouter: RouterFeatureInterface<
  'ReorderListSCRouter',
  '/dashboard/reorder-list-sc'
> = {
  name: 'ReorderListSCRouter',
  Component: ReorderListSC,
  path: '/dashboard/reorder-list-sc',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: ReorderListScRBAC.pageID,
}

export const ReorderListHistoryRouter: RouterFeatureInterface<
  'ReorderListHistoryRouter',
  '/dashboard/reorder-list-history'
> = {
  name: 'ReorderListHistoryRouter',
  Component: ReorderListHistory,
  path: '/dashboard/reorder-list-history',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: ReorderListHistoryRBAC.pageID,
}

export const ReorderListSavePreviewRouter: RouterFeatureInterface<
  'ReorderListSavePreviewRouter',
  '/dashboard/reorder-list/save-preview'
> = {
  name: 'ReorderListSavePreviewRouter',
  Component: ReorderListSavePreview,
  path: '/dashboard/reorder-list/save-preview',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: ReorderListPreviewRBAC.pageID,
}

const ReorderListRouter = [
  ReorderListSourcingRouter,
  ReorderListSCRouter,
  ReorderListSavePreviewRouter,
  ReorderListHistoryRouter,
]

export const ReorderListRouterDetail = generateRouterDetail(ReorderListRouter)

export default ReorderListRouter
